import React, {Component} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Colxx} from '../components/common/CustomBootstrap';
import {reactTableText} from '../constants/configs';
import Rbac from '../components/Rbac';
import ReactTable from 'react-table';
import Api from '../services/Api';
import {i18nizeDate} from '../helpers/Utils';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from '../components/common/react-notifications';

class UserPrivateNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
      pages: -1,
      loading: false,
    };
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/user-notifications',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            userId: this.props.userId,
          }
        }
      );
      this.setState({
        notifications: data.notifications,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  deleteNotification = async id => {
    const {t} = this.props;
    try {
      await Api.invoke('DELETE', '/admin-ui/user-notifications', {id});
      NotificationManager.success(t('Notification deleted successfully'), t('Message'));
      this.table.fireFetchData();
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressCreate = () => {
    this.props.history.push('/dashboard/notifications/actions/create', {
      userId: this.props.userId,
    });
  };

  onPressDelete = id => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete this notification ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.deleteNotification(id);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  getColumns = t => [
    {
      Header: t('Title'),
      accessor: 'title',
    },
    {
      Header: t('Date'),
      accessor: 'createdAt',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('Status'),
      accessor: 'seen',
      Cell: props =>
        <span className={props.value ? 'text-success' : 'text-danger'}>
          {props.value ? t('Seen') : t('Not Seen')}
        </span>,
    },
    {
      Header: t('Actions'),
      width: 100,
      Cell: props => <div>
        <Rbac permission='delete_user-notifications'>
          <i
            className="simple-icon-trash delete-icon mx-3 cursor-pointer"
            onClick={() => {this.onPressDelete(props.original.id);}}
          />
        </Rbac>
        <Rbac permission='update_user-notifications'>
          <Link to={{
            pathname: '/dashboard/notifications/actions/update',
            state: {
              notification: props.original,
              userId: this.props.userId,
            },
          }}>
            <i className="simple-icon-pencil edit-icon mx-3 cursor-pointer"/>
          </Link>
        </Rbac>
      </div>,
      show: Rbac.hasPermission('update_user-notifications') || Rbac.hasPermission('delete_user-notifications'),
    },
  ];

  render() {
    const {t} = this.props;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary d-flex flex-row justify-content-between align-items-center">
                {t('User Notifications')}
                <Rbac permission='create_user-notifications'>
                  <Button onClick={this.onPressCreate}>
                    <i className="simple-icon-plus add-reply-icon"/>
                    <span className="mx-1">{t('Add')}</span>
                  </Button>
                </Rbac>
              </CardTitle>
              <ReactTable
                manual
                ref={el => {this.table = el;}}
                className="-highlight"
                data={this.state.notifications}
                pages={this.state.pages}
                loading={this.state.loading}
                sortable={false}
                resizable={true}
                onFetchData={this.fetchData}
                columns={this.getColumns(t)}
                defaultPageSize={10}
                style={{
                  width: '100%'
                }}
                {...reactTableText}
              />
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(UserPrivateNotifications);
